import React from 'react'
import {StyledDialog, DialogBox} from './styles'
import {Workshop} from '../../redux/workshop'
import DocViewer, {DocViewerRenderers} from 'react-doc-viewer'

type Props = {
  open: boolean
  setOpen: (value: boolean) => void
  workshop?: Workshop
}

const View = ({open, setOpen, workshop}: Props) => {
  const handleClose = () => {
    setOpen(false)
  }

  const getGoogleDriveFileId = (url: string) => {
    const match = url.match(/\/d\/(.*?)(\/|$)/)
    return match ? match[1] : null
  }

  const renderDocument = (link: string) => {
    const fileId = getGoogleDriveFileId(link)
    const proxyUrl = `${process.env.REACT_APP_BKS_PLATFORM_SERVICES_URL}/v1/guest/are/workshops/slides/${fileId}`
    const docs = [{uri: proxyUrl}]

    return (
      <DocViewer
        documents={docs}
        pluginRenderers={DocViewerRenderers}
        style={{width: '100%', height: '600px'}}
      />
    )
  }

  return (
    <StyledDialog maxWidth={'lg'} onClose={handleClose} open={open}>
      <DialogBox>
        {workshop ? renderDocument(workshop.slidesLink) : null}
      </DialogBox>
    </StyledDialog>
  )
}

export default View
